import { Box, Paper, TextField, useMediaQuery } from "@mui/material";
import { PaperStyles } from "../../styles/commonStyles";
import SubmitButton from "../buttons/submitButton.component";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  deleteFieldTypeStart,
  resetCreateFieldTypeState,
  resetUpdateFieldTypeState,
} from "../../store/features/fieldType/fieldTypeSlice";
import { Delete } from "@mui/icons-material";
import CustomDialog from "../muiDialogs/dialog.component";
import { dialogMessages } from "./utils";
import FormActionButton from "../buttons/formActionButton.component";
import SuccessDialog from "../muiDialogs/successDialog.component";

const FieldTypeForm = ({
  defaultValues = {},
  onSubmit,
  isLoading,
  mode = "create",
  error,
  success,
  accessToken,
  fieldType,
}) => {
  const isDesktop = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState(null);
  const [isAction, setIsAction] = useState(false);

  const isUpdateMode = mode === "update";

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogConfirm = () => {
    if (dialogMode) {
      dispatch(
        deleteFieldTypeStart({ fieldTypeId: fieldType.id, accessToken })
      );
      setDialogOpen(false);
    }
  };

  const handleSuccessDialogConfirm = () => {
    dispatch(resetCreateFieldTypeState());
    dispatch(resetUpdateFieldTypeState());
    setDialogOpen(false);
    navigate("/admin/fieldsType");
  };

  useEffect(() => {
    if (success && !dialogOpen) {
      setDialogOpen(true);
    }
  }, [success, dialogOpen]);

  useEffect(() => {
    if (success && dialogMode === "delete") {
      dispatch(resetCreateFieldTypeState());
      dispatch(resetUpdateFieldTypeState());
      navigate("/admin/fieldsType");
    }
  }, [success, dialogMode, navigate, dispatch]);

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper sx={PaperStyles} elevation={0}>
          {isUpdateMode && (
            <Box width="100%" display="flex" justifyContent="end" mb={2}>
              <FormActionButton
                startIcon={<Delete />}
                color="error"
                label="Elimina"
                onClick={() => {
                  setDialogMode("delete");
                  setIsAction(true);
                  setDialogOpen(true);
                }}
              />
            </Box>
          )}
          <Box
            display="flex"
            alignItems="center"
            gap="16px"
            justifyContent="center"
            flexDirection={isDesktop ? "row" : "column"}
          >
            <TextField
              variant="filled"
              id="field-type-name"
              label="Nome tipologia"
              fullWidth
              sx={{ "& .MuiFilledInput-root": { height: "50px" } }}
              {...register("name", { required: "Campo obbligatorio" })}
              error={!!errors.name || !!error}
              helperText={errors.name?.message}
              disabled={isLoading}
            />
          </Box>
        </Paper>
        <SubmitButton
          label={isUpdateMode ? "Aggiorna tipologia" : "Salva tipologia"}
          type="submit"
          disabled={isLoading}
        />
      </form>
      {dialogMode ? (
        <CustomDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleDialogConfirm}
          title={dialogMessages.fieldType[dialogMode || mode].title}
          description={dialogMessages.fieldType[dialogMode || mode].description}
          actions={isAction}
        />
      ) : (
        <SuccessDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleSuccessDialogConfirm}
          title={dialogMessages.fieldType[dialogMode || mode].title}
          description={dialogMessages.fieldType[dialogMode || mode].description}
        />
      )}
    </Box>
  );
};

export default FieldTypeForm;
